import PropTypes from 'prop-types';
export const datePropTypes = {
  /**
   * The label of action
   */
  label: PropTypes.string.isRequired,
  /**
   * The datetime represents a specific period in time in machine-readable format YYYY-MM-DD
   */
  datetime: PropTypes.string.isRequired,
  /**
   * The date of action
   */
  date: PropTypes.string.isRequired
};